/**
 * @prettier
 */
import _isNumber from 'lodash/isNumber';

export const isNumber = _isNumber;
